import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";

const OPPORTUNITIES = [
  { title: "Software Builds", d: "Equity, revenue-share, or co-build on SaaS and platform concepts." },
  { title: "Domain Portfolio Acquisitions", d: "Full portfolio purchase or strategic partnership at $250K." },
  { title: "Lead-Generation Projects", d: "Funded build-out of geo-targeted lead-gen funnels and properties." },
  { title: "SaaS Development", d: "Co-investment in vertical SaaS products with proprietary IP." },
  { title: "Marketing Automation", d: "Operational rollups and automation overlays for service businesses." },
  { title: "Business Consulting", d: "Retainer or project-based engagements for growth and digital transformation." },
  { title: "Revenue-Share Projects", d: "Joint ventures where we contribute IP, infrastructure, or distribution." },
  { title: "Digital Asset Sales", d: "Brokerage and packaging of premium domains and branded web properties." },
];

export default function Investors() {
  return (
    <>
      <section className="pt-32 pb-16 md:pt-40 relative" data-testid="investors-page">
        <div className="absolute inset-0 grid-bg radial-mask opacity-40" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
            <div className="lg:col-span-8">
              <div className="eyebrow mb-4">Investors · Partners</div>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-slate-900">
                Partner With S&amp;B Technologies.
              </h1>
              <p className="mt-6 text-base md:text-lg text-slate-600 max-w-2xl leading-relaxed">
                S&amp;B Technologies works with investors, business owners, domain buyers,
                startups, and strategic partners looking to build, acquire, or monetize digital
                assets and software platforms.
              </p>
            </div>
            <div className="lg:col-span-4">
              <div className="tracing-card p-6 border-[#C8961F]/40">
                <div className="eyebrow mb-2" style={{ color: "#C8961F" }}>
                  // Featured Opportunity
                </div>
                <div className="font-display text-3xl font-semibold text-slate-900">$250,000</div>
                <p className="mt-2 text-sm text-slate-600">
                  Strategic partnership · 50% down · Balance over 12 months
                </p>
                <Link
                  to="/contact?type=Investor%20%2F%20Partnership%20Opportunity"
                  className="mt-5 btn-gold w-full justify-center"
                  data-testid="investors-featured-cta"
                >
                  Request Terms <ArrowRight size={14} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {OPPORTUNITIES.map((o, i) => (
              <div key={o.title} className="tracing-card p-8" data-testid={`opportunity-${i}`}>
                <div className="flex items-start gap-4">
                  <div className="mt-1 flex h-6 w-6 items-center justify-center border border-[#0066FF]/40 text-[#0066FF] shrink-0">
                    <Check size={12} />
                  </div>
                  <div>
                    <h3 className="font-display text-lg font-semibold text-slate-900">{o.title}</h3>
                    <p className="mt-2 text-sm text-slate-600 leading-relaxed">{o.d}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 tracing-card p-10 md:p-14 text-center relative overflow-hidden">
            <div
              className="absolute inset-0 opacity-30 pointer-events-none"
              style={{
                background:
                  "radial-gradient(500px 250px at 50% 0%, rgba(200,150,31,0.18), transparent)",
              }}
            />
            <div className="relative">
              <div className="eyebrow mb-3">Next Step</div>
              <h2 className="font-display text-3xl md:text-4xl font-semibold text-slate-900">
                Request Partnership Information
              </h2>
              <p className="mt-4 text-base text-slate-600 max-w-2xl mx-auto">
                Tell us about your investment thesis, capital range, or partnership interest.
                Our team will follow up with a tailored proposal.
              </p>
              <Link
                to="/contact?type=Investor%20%2F%20Partnership%20Opportunity"
                className="mt-8 btn-gold inline-flex"
                data-testid="investors-bottom-cta"
              >
                Request Partnership Information <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
